import * as Types from './types';

const getMultimedias = postingId => ({
  type: Types.GET_STEP_MULTIMEDIA,
  meta: {
    async: true,
    blocking: false,
    api: 'publicador',
    path: `/publicador/api/v1/postings/STEP_MULTIMEDIA/${postingId}`,
    method: 'GET'
  }
});

const deleteMultimedia = (id, multimediaType) => ({
  type: Types.DELETE_MULTIMEDIA,
  payload: {
    id,
    type: multimediaType
  }
});

const addErrorMultimedia = (id, multimediaType, keyError) => ({
  type: Types.ADD_ERROR_MULTIMEDIA,
  payload: {
    id,
    type: multimediaType,
    keyError
  }
});

const updateMultimedia = (multimedia, multimediaType) => ({
  type: Types.UPDATE_MULTIMEDIA,
  payload: {
    multimedia,
    type: multimediaType
  }
});

const addMultimedia = (multimedia, multimediaType) => ({
  type: Types.ADD_MULTIMEDIA,
  payload: {
    multimedia,
    type: multimediaType
  }
});

const moveMultimedia = (dragIndex, hoverIndex, multimediaType) => ({
  type: Types.MOVE_MULTIMEDIA,
  payload: {
    dragIndex,
    hoverIndex,
    type: multimediaType
  }
});

const bulkActionMultimedia = (actions = []) => {
  return {
    type: Types.BULK_ACTION_MULTIMEDIA,
    meta: {
      bulk: true,
      data: [...actions]
    }
  };
};

const cleanMultimedia = multimediaType => ({
  type: Types.CLEAN_MULTIMEDIA,
  payload: {
    type: multimediaType
  }
});

const setProcessingMultimedia = ({ key, status }) => ({
  type: Types.PROCESSING_MULTIMEDIA,
  payload: {
    key,
    val: status === 'LOADING'
  }
});

export {
  getMultimedias,
  updateMultimedia,
  addMultimedia,
  deleteMultimedia,
  bulkActionMultimedia,
  moveMultimedia,
  setProcessingMultimedia,
  addErrorMultimedia,
  cleanMultimedia
};
